import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Cookies from 'universal-cookie';

const parseJwt = (token) => {
  try {
    return JSON.parse(atob(token.split('.')[1]));
  } catch (e) {
    return null;
  }
};
const cookies = new Cookies();

class AuthVerify extends Component {
  constructor(props) {
    super(props);

    this.loggingOut = false;

    props.history.listen(() => {
      const user = cookies.get('accessToken');

      if (user) {
        const decodedJwt = parseJwt(user);

        // parseJwt returns null for a malformed token. Treat that the same as
        // an expired one rather than throwing inside the history listener.
        if (!decodedJwt || !decodedJwt.exp || decodedJwt.exp * 1000 < Date.now()) {
          // logOut() navigates away; guard against the listener re-entering
          // while that navigation is still pending.
          if (!this.loggingOut) {
            this.loggingOut = true;
            props.logOut();
          }
        }
      }
    });
  }

  render() {
    return <div></div>;
  }
}

export default withRouter(AuthVerify);